<template>
  <NotificationComponent :description="$t('notification_fop_expiring')" v-bind="$attrs">
    <template #ctaContent>
      <div class="tw:shrink-0">
        <BaseLinkButton size="medium" class="tw:w-full tw:font-bold tw:text-blue-800" @click="notificationAction">
          <span>{{
            hasAdminOrSupport ? $t('notifications_cta_update') : $t('log_in_admin_fop')
          }}</span>
        </BaseLinkButton>
      </div>
    </template>
  </NotificationComponent>
</template>

<script setup>
import { useStore } from 'vuex'

import { useRouter } from 'vue-router'

import NotificationComponent from './NotificationComponent.vue'
import BaseLinkButton from '@/components/base/buttons/BaseLinkButton.vue'
import { useSessionValues } from '@/composables/useSessionValues'

const router = useRouter()
const store = useStore()
const { hasAdminOrSupport } = useSessionValues()
defineProps({
  extraParameters: {
    type: [Object, null],
    required: true,
    default: null,
  },
})

const notificationAction = () => {
  if (hasAdminOrSupport.value) {
    router.push({ name: 'billing-edit-payment' })
  } else {
    store.dispatch('session/logout', '/billing/payment-methods/edit-payment/?loginAsAdmin=true')
  }
}
</script>
